import React from 'react';

import classNames from 'classnames/bind';
import {
  ReactionActionType,
  ReactionsType,
} from 'shared_DEPRECATED/components/Reactions/types';
import Spacer from 'shared_DEPRECATED/components/Spacer/Spacer';
import { Attachment } from 'shared_DEPRECATED/types/Attachment';

import { ChatMessageNewDelimiter } from 'features/chat/components/ChatMessages/ChatMessageNewDelimiter';
import { CHAT_MESSAGE_TYPES } from 'features/chat/config';
import { UnuploadedAttachment } from 'features/chat/config/types/Attachment';
import {
  MESSAGE_STATUS,
  MessageContentBasedOnType,
  UUID,
} from 'features/chat/config/types/Message';
import { ParentMessageNullable } from 'features/chat/config/types/ParentMessage';
import { SendMorpheusMessage } from 'features/chat/config/types/types';

import {
  isChatMessageMorpheusSuggestionsType,
  isChatMessageMorpheusType,
  isChatMessagePlainType,
  isChatMessageSessionRecapType,
  isChatMessageWidgetsType,
} from '../../utils/chatMessageUtils';
import { DeletedMessage } from './ChatMessage/DeletedMessage';
import { MorpheusSuggestionsMessage } from './ChatMessage/MorpheusSuggestionsMessage';
import { StandardMessage } from './ChatMessage/StandardMessage';
import { SystemMessage } from './ChatMessage/SystemMessage';
import { WidgetsMessage } from './ChatMessage/WidgetsMessage';
import styles from 'features/chat/components/Chat.module.css';

const cx = classNames.bind(styles);

type ChatMessageProps = {
  key: string;
  id: UUID;
  text: string;
  createdAt: string;
  editedAt?: string;
  divide: string;
  newMessageDelimiter: boolean;
  status: MESSAGE_STATUS;
  incoming: boolean;
  isMorpheus: boolean;
  markAsRead: (inView: boolean) => void;
  sendReaction: (
    messageId: UUID,
    emoji: string,
    type: ReactionActionType
  ) => void;
  retrySendingMessage: (id: string) => void;
  reactions: ReactionsType;
  attachments?: Attachment[] | UnuploadedAttachment[];
  isTemporary: boolean;
  replyToMessage: ParentMessageNullable;
  fromUserId: string;
  content: MessageContentBasedOnType;
  sendMorpheusMessage: SendMorpheusMessage;
  shouldMorpheusButtonGlow: boolean;
};

export default function ChatMessage({
  id,
  text,
  createdAt,
  editedAt,
  divide,
  newMessageDelimiter,
  status,
  incoming,
  isMorpheus,
  markAsRead,
  reactions,
  sendReaction,
  retrySendingMessage,
  attachments,
  isTemporary,
  replyToMessage,
  fromUserId,
  content,
  sendMorpheusMessage,
  shouldMorpheusButtonGlow,
}: ChatMessageProps) {
  const renderMessage = () => {
    switch (content.type) {
      case CHAT_MESSAGE_TYPES.MORPHEUS_SUGGESTION:
        if (isChatMessageMorpheusSuggestionsType(content)) {
          return (
            <MorpheusSuggestionsMessage
              content={content}
              sendMorpheusMessage={sendMorpheusMessage}
            />
          );
        }
        return null;

      case CHAT_MESSAGE_TYPES.WIDGETS:
        if (isChatMessageWidgetsType(content)) {
          return <WidgetsMessage id={id} content={content} />;
        }
        return null;

      case CHAT_MESSAGE_TYPES.SYSTEM:
        return <SystemMessage text={text} />;

      case CHAT_MESSAGE_TYPES.DELETED:
        return <DeletedMessage text={text} incoming={incoming} />;

      default:
        if (
          isChatMessagePlainType(content) ||
          isChatMessageMorpheusType(content) ||
          isChatMessageSessionRecapType(content)
        ) {
          return (
            <StandardMessage
              id={id}
              text={text}
              createdAt={createdAt}
              editedAt={editedAt}
              status={status}
              incoming={incoming}
              isMorpheus={isMorpheus}
              markAsRead={markAsRead}
              sendReaction={sendReaction}
              retrySendingMessage={retrySendingMessage}
              reactions={reactions}
              attachments={attachments}
              isTemporary={isTemporary}
              replyToMessage={replyToMessage}
              fromUserId={fromUserId}
              content={content}
              sendMorpheusMessage={sendMorpheusMessage}
              shouldMorpheusButtonGlow={shouldMorpheusButtonGlow}
            />
          );
        }
        return null;
    }
  };

  return (
    <div>
      {(divide || newMessageDelimiter) && <Spacer size="md zr lg zr" />}
      {newMessageDelimiter && <ChatMessageNewDelimiter />}
      {divide && <div className={cx('chat__date-divide')}>{divide}</div>}
      <Spacer size="md zr lg zr" />
      {renderMessage()}
    </div>
  );
}
